import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=971f69cc&"
import script from "./LoginDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VForm,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971f69cc')) {
      api.createRecord('971f69cc', component.options)
    } else {
      api.reload('971f69cc', component.options)
    }
    module.hot.accept("./LoginDialog.vue?vue&type=template&id=971f69cc&", function () {
      api.rerender('971f69cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/LoginDialog.vue"
export default component.exports